import styled from 'styled-components';

export const StyledFooter = styled.footer`
  height: var(--footer-height);
  padding: 16px var(--side-padding) 24px;

  & > div {
    min-height: 100%;
  }
`;

export const StyledFooterContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
`;

export const StyledFooterNavigation = styled.div`
  display: flex;
  justify-content: space-between;

  & div:last-of-type {
    justify-content: flex-end;

    button {
      text-align: right;
    }
  }
`;

export const StyledFooterNavButton = styled.div`
  display: flex;
  align-items: center;
  width: 25%;

  button {
    min-width: 100%;
    min-height: 100%;
    text-align: left;
    padding: 0 16px;
    cursor: pointer;
    background-color: transparent;
    border: none;
    outline: none;
    color: #dce3e9;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.5px;
    display: inline-flex;
    align-items: center;
    gap: 16px;
  }
`;
export const StyledFooterRightNavButton = styled(StyledFooterNavButton)`
  button {
    justify-content: flex-end;
    padding-right: 0;
  }
`;
export const StyledFooterLeftNavButton = styled(StyledFooterNavButton)`
  button {
    justify-content: flex-start;
    padding-left: 0;
  }
`;

export const StyledFooterMenu = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;

  button {
    color: #fff;
    height: 96px;
    width: 96px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: none;
    padding: 0;
    outline: none;
    cursor: pointer;
  }

  svg {
    width: 32px;
    height: 32px;
  }
`;

export const StyledSliderIndicator = styled.div<{
  activeSlideIndex: number;
  items: number;
}>`
  display: flex;
  align-items: center;

  span {
    width: 100%;
    display: block;
    height: 4px;
    background-color: #6c7784;
    position: relative;

    span {
      position: absolute;
      left: ${(props) => {
        return `calc(100% / ${props.items} * ${props.activeSlideIndex})`;
      }};
      width: ${(props) => {
        return `calc(100% / ${props.items})`;
      }};
      height: 100%;
      background-color: #f2f5f8;
      transition: left 0.3s linear;

      &:after {
        position: absolute;
        content: '';
        width: ${(props) => {
          if (props.items - 1 !== props.activeSlideIndex) {
            return '4px';
          }
          return 0;
        }};
        right: 0;
        height: 100%;
        background-color: #202327;
      }

      &:before {
        position: absolute;
        content: '';
        left: 0;
        width: ${(props) => {
          if (props.activeSlideIndex > 0) {
            return '4px';
          }
          return 0;
        }};
        height: 100%;
        background-color: #202327;
      }
    }
  }
`;
